import React from "react";
import _ from "lodash";
import cx from "classnames";
import ButtonBack from "Components/buttonBack/ButtonBack";

const Stepper = ({ steps, active, goBack, className, hideBackButton }) => {
  return (
    <div className={cx("flex gap-1 w-full items-center", className)}>
      <div className="flex-1">
        {!hideBackButton && <ButtonBack className={active < 1 && "invisible"} onClick={goBack} />}
      </div>
      <div className="flex-[3] flex gap-1">
        {_.times(steps, (i) => (
          <div
            key={i}
            className={cx("flex-1 h-[0.125rem]", {
              ...(active >= i ? { ["bg-[--accent]"]: true } : { ["bg-[--bg-d5]"]: true }),
            })}
          />
        ))}
      </div>
      <div className="flex-1" />
    </div>
  );
};

export default Stepper;
